import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { MMKV } from "react-native-mmkv";
import { type PersistConfig, type Storage, persistReducer } from "redux-persist";
import extraReducers from "../extraReducers";
import type { InvoiceFormValues } from "./types";

import { isWeb } from "@stepapp/core";
import type { Bundle } from "@stepapp/core/apiTypes";

export const initialState = {
  companyName: "",
  nipNumber: "",
  addressFirstLine: "",
  addressSecondLine: "",
  postalOrZipCode: "",
  city: "",
  date: "",
  localizationId: "",
  predefinedProfileIds: [] as string[],
  service: null as Maybe<Bundle>,
  setupIntentId: "",
  summaryDetailsId: null as Maybe<number>,
  voucher: null as Maybe<string>,
};

const draftReservationSlice = createSlice({
  name: "draftReservation",
  initialState,
  extraReducers: extraReducers(initialState),
  reducers: {
    setDraftDate: (state, { payload }: PayloadAction<string>) => {
      state.date = payload;
    },
    setDraftVoucher: (state, { payload }: PayloadAction<string | null>) => {
      state.voucher = payload;
    },

    setFieldValue: (
      state,
      action: PayloadAction<{ key: keyof InvoiceFormValues; value: string }>,
    ) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },

    clearDraftService: () => initialState,
  },
});

export const { clearDraftService, setDraftDate, setDraftVoucher, setFieldValue } =
  draftReservationSlice.actions;

const storage = new MMKV(isWeb ? undefined : { id: "customer-store-reservation" });

const reduxStorage = (): Storage => ({
  setItem: (key, value) => {
    storage.set(key, value);
    return Promise.resolve(true);
  },
  getItem: (key) => {
    const value = storage.getString(key);
    return Promise.resolve(value);
  },
  removeItem: (key) => {
    storage.delete(key);
    return Promise.resolve();
  },
});

const persistConfig: PersistConfig<ReturnType<typeof draftReservationSlice.reducer>> = {
  key: "draftReservation",
  whitelist: [
    "localizationId",
    "companyName",
    "nipNumber",
    "addressFirstLine",
    "addressSecondLine",
    "postalOrZipCode",
    "city",
  ],
  storage: reduxStorage(),
};

const draftReservationReducer = persistReducer(persistConfig, draftReservationSlice.reducer);

export default draftReservationReducer;
